/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
/* eslint-disable react/no-array-index-key */
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import Inspector from 'react-inspector';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Loader } from '../../../components/Loader';
import { selectWork, selectConfig } from '../../Api/selectors';
import { addCarCollectDocument, addCarCollectInvoice, carcollectAwards, carcollectCreate } from '../actions';
import { ADD_CAR_COLLECT_DOCUMENT, ADD_CAR_COLLECT_INVOICE, REQUEST_CAR_COLLECT } from '../constants';
import { VehicleInvoicesCard } from '../components/VehcleInvoicesCard';
import { InvoiceListItem } from '../../Invoices/components/InvoiceListItem';
import { ActionsContainer, IconWrapper } from '../../Invoices/components/InvoicesCompanyTable';
import { Upload, Check } from '../../../components/Icon';
import { Warnings } from '../../Api/Warnings';
import { DocumentsList } from "../../Documents/components/documentsList";
import { Card } from '../../../components/Card';
import { CarcollectCredentialModal } from '../components/CarcollectCredentialModal';

const Container = styled.div``;

const STATE = {
  awards: 0,
  addInvoiceError: null,
  addDocumentError: null,
  showCredentialModal: false,
};

let MANDATORY_FIELDS_CARCOLLECT = [
  'mileage',
  'brand_name',
  'model_name',
];

/* eslint-disable react/prefer-stateless-function */
class VehicleCarcollectComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    if (this.vehicle?.carcollect_tradedossier_id) {
     // this.loadAwards();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.vehicle?.carcollect_tradedossier_id !== prevProps.vehicle?.carcollect_tradedossier_id) {
      this.loadAwards();
    }
  }

  reset() {
    this.setState({ ...STATE });
  }

  get vehicle() {
    return this.props.vehicle;
  }

  get entityId() {
    return this.vehicle?.id;
  }

  get entityType() {
    return 'vehicle';
  }

  onResult(result) {
    this.setState({ result });

    // if (this.vehicle.carcollect_tradedossier_id) {
    //   this.loadAwards();
    // }
  }

  loadAwards() {
    this.props.getCarcollectAwards(this.vehicle.carcollect_tradedossier_id, (result) => {
      this.setState({ awards : result?.awards || 0 });
    });
  }

  addInvoice(invoiceId) {
    this.props.addCarCollectInvoice(this.vehicle?.id, invoiceId, (res) => {
      if (res.error) {
        this.setState({ addInvoiceError : res.error });
      }
    });
  }

  addDocument(docId) {
    this.props.addCarCollectDocument(this.vehicle?.id, docId, (res) => {
      if (res.error) {
        this.setState({ addDocumentError : res.error });
      }
    });
  }

  handleCreateClick = () => {
    const { serverConfig } = this.props;

    // Check if there are multiple credentials available
    if (serverConfig?.carcollectCredentials?.length > 0) {
      this.setState({ showCredentialModal: true });
      console.log('Multiple credentials available, showing modal');
    } else {
      // No credentials or single credential - proceed directly

      this.props.create(this.onResult.bind(this));
    }
  }

  handleCredentialConfirm = (credentialId) => {
    this.setState({ showCredentialModal: false });
    this.props.create(this.onResult.bind(this), credentialId);
  }

  handleCredentialCancel = () => {
    this.setState({ showCredentialModal: false });
  }

  create() {}

  render() {
    if (this.props.loading) return <Loader small />;

    let carCollectUploads = {};
    try {
      carCollectUploads = this.vehicle.carcollect_tradedossier_uploads ? JSON.parse(this.vehicle.carcollect_tradedossier_uploads) : {};
    } catch(err) {
      console.log(err);
    }
    const missingFields = MANDATORY_FIELDS_CARCOLLECT.filter(field => !this.vehicle[field]);


    return (
      <Container>
        <VBox gap={14}>




              <>
                <h1>{this.lbl('carcollect.dossiernummer')}{this.vehicle.carcollect_tradedossier_id}</h1>
                <span>{this.lbl('carcollect.awards')} {this.state.awards}</span>

              <Button onClick={this.handleCreateClick}>{this.lbl('create')}</Button>
            </>







          {this.vehicle.carcollect_tradedossier_id && (
            <VBox>
              {!!this.state.addInvoiceError && (
                <Warnings
                  static
                  message={this.state.addInvoiceError}
                  hideWarning={() => this.setState({ addInvoiceError : null })}
                />
              )}
              <div style={{width: '100%', margin: '0 -5px'}}>
                <VehicleInvoicesCard
                  isInvoicePage
                  vehicle={this.vehicle}
                  ActionsColComp={(data) => {
                    return (
                      <ActionsContainer>
                        <IconWrapper color={'green'}>
                          {carCollectUploads?.invoices?.length && carCollectUploads?.invoices.find(id => id == data.value.id) ? (
                            <Check />
                          ) : (
                            <Button
                              disabled={this.props.invoiceLoading}
                              onClick={() => {
                                this.addInvoice(data.value.id);
                              }}
                            >
                              {!this.props.invoiceLoading ? <Upload/> : <Loader small/>}
                            </Button>
                          )}
                        </IconWrapper>
                      </ActionsContainer>
                    );
                  }}
                />
              </div>
              {!!this.state.addDocumentError && (
                <Warnings
                  static
                  message={this.state.addDocumentError}
                  hideWarning={() => this.setState({ addDocumentError : null })}
                />
              )}
              <Card className="vehicle-info-card info-card data wide">
                <DocumentsList
                  invoiceDetails
                  entityId={this.vehicle.id}
                  entityType="vehicle"
                  items={this.vehicle.documents}
                  vehicle={this.props.vehicle}
                  Actions={(data) => (
                    carCollectUploads?.documents?.length && carCollectUploads?.documents.find(id => id == data.value.id) ? (
                      <Check />
                    ) : (
                      <Button
                        disabled={this.props.documentLoading}
                        onClick={() => {
                          this.addDocument(data.value.id);
                        }}
                      >
                        {!this.props.documentLoading ? <Upload/> : <Loader small/>}
                      </Button>
                    )
                  )}
                />
              </Card>
            </VBox>

          )}
        </VBox>

        {this.state.showCredentialModal && (
          <CarcollectCredentialModal
            onConfirm={this.handleCredentialConfirm}
            onCancel={this.handleCredentialCancel}
          />
        )}
      </Container>
    );
  }
}

VehicleCarcollectComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loading: selectWork(REQUEST_CAR_COLLECT),
    invoiceLoading: selectWork(ADD_CAR_COLLECT_INVOICE),
    documentLoading: selectWork(ADD_CAR_COLLECT_DOCUMENT),
    serverConfig: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    getCarcollectAwards(carcollectVehicleId, callback) {
      dispatch(carcollectAwards(carcollectVehicleId, callback));
    },
    create(callback, credentialId) {
      dispatch(carcollectCreate(ownProps.vehicle.id, callback, credentialId));
    },
    addCarCollectInvoice(vehicleId, invoiceId, callback) {
      dispatch(addCarCollectInvoice(vehicleId, invoiceId, callback));
    },
    addCarCollectDocument(vehicleId, documentId, callback) {
      dispatch(addCarCollectDocument(vehicleId, documentId, callback));
    }
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCarcollect = compose(withConnect, withRouter, injectIntl)(VehicleCarcollectComp);
